/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Confirm_Return_Defect_Qty_MinInputs */

const vi_confirm_return_defect_qty_min = /** @type {(inputs: Confirm_Return_Defect_Qty_MinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SL lỗi phải lớn hơn 0`)
};

/**

* @param {Confirm_Return_Defect_Qty_MinInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const confirm_return_defect_qty_min = /** @type {((inputs?: Confirm_Return_Defect_Qty_MinInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_Return_Defect_Qty_MinInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_confirm_return_defect_qty_min(inputs)
});